module.exports = "/assets/1825373a233e03ecd089c192ac041ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PA.png
// module id = 1709
// module chunks = 0